import { useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setTokens, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export function GoogleButton({ owner = false }) {
  const go = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + (owner ? "/owner" : "/portal");
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button type="button" onClick={go} className="btn w-full bg-white text-ink hover:bg-tan" data-testid="google-login-btn">
      <svg viewBox="0 0 24 24" className="w-4 h-4" aria-hidden="true"><path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.3-1.6 3.8-5.5 3.8-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.8 3.2 14.6 2.2 12 2.2 6.6 2.2 2.3 6.6 2.3 12s4.3 9.8 9.7 9.8c5.6 0 9.3-3.9 9.3-9.5 0-.6-.1-1.1-.2-1.6H12z" /></svg>
      Continue with Google
    </button>
  );
}

export function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(loc.hash.slice(1)).get("session_id");
    const owner = loc.pathname.startsWith("/owner");
    api.post("/auth/google", { session_id: sid, portal: owner ? "owner" : "client" })
      .then(({ data }) => { setTokens(data); setUser(data.user); nav(owner ? "/owner" : "/portal", { replace: true }); })
      .catch((e) => { toast.error(errMsg(e, "Google sign-in failed.")); nav(owner ? "/owner/login" : "/login", { replace: true }); });
  }, [loc, nav, setUser]);
  return <div className="min-h-screen bg-ink" data-testid="auth-callback" />;
}
